import type { ComponentType } from "react";

import Private001Dashboard from "@/modules/private-001/dashboard";
import StandardDashboard from "@/pages/common/Dashboard";
import { useDeploymentStore } from "@/store/deployment.store";
import type { DashboardOverrideEntry } from "./deployment.types";

const DASHBOARD_OVERRIDES: Record<DashboardOverrideEntry, ComponentType> = {
  "private-001": Private001Dashboard,
};

export default function DashboardEntry() {
  const dashboard = useDeploymentStore((state) => state.profile.dashboard);
  const Dashboard =
    dashboard.mode === "replace" ? DASHBOARD_OVERRIDES[dashboard.entry] : StandardDashboard;

  return <Dashboard />;
}
